export default "__VITE_ASSET__xVlMgA8f__"